module.exports = __webpack_public_path__ + "static/media/make_an_offer.957c5bd0.png";